import { flexRender, type Row } from '@tanstack/react-table'
import { TableCell, TableRow } from '~/shadcn/ui/table'
import { cn } from '~/shadcn/lib/utils'
import type { UserWithMeta } from '~/@biz_account/useUser/types'
import { isProjectBlurred } from '../project-blurred-content/isProjectBlurred'
import type { ProjectsItem } from '../../_project_types/project.types'

type Props = {
  row: Row<ProjectsItem>
  userWithMeta?: UserWithMeta
  navigate: (path: string) => void
  isActiveProject?: boolean
  enableAdvancedStyles?: boolean
  colorScheme?: 'dark' | 'light'
  rowIndex?: number
}

export function ProjectsTableRow({
  row,
  userWithMeta,
  navigate,
  isActiveProject = true,
  enableAdvancedStyles = false,
  colorScheme = 'dark',
  rowIndex = 0,
}: Props) {
  const isDark = colorScheme === 'dark'
  const isBlurred = isActiveProject
    ? isProjectBlurred(
        row.original.blurTags,
        userWithMeta?.['meta']?.tags ?? []
      )
    : true

  const isOdd = rowIndex % 2 !== 0

  const getRowClassName = () => {
    if (enableAdvancedStyles) {
      return cn(
        'h-20',
        isBlurred ? 'cursor-default' : 'cursor-pointer',
        isOdd ? 'bg-transparent' : isDark ? 'bg-muted/10' : 'bg-muted/20',
        !isBlurred && 'hover:bg-accent/30',
        isBlurred && 'hover:bg-muted/40'
      )
    }
    return 'cursor-pointer'
  }

  return (
    <TableRow
      key={`TableRow-${row.id}`}
      onClick={(event: React.MouseEvent<HTMLTableRowElement>) => {
        event.preventDefault()
        if (isBlurred) return
        navigate(
          `/projects/${row.original.businessId}/${row.original.stageNumber}`
        )
      }}
      className={getRowClassName()}>
      {row.getVisibleCells().map((cell, index) => (
        <TableCell
          key={`TableCell-${cell.id}`}
          className={cn(
            isDark ? 'border-border-strong' : 'border-border',
            index === 0 && `border-r`,
            ''
          )}>
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </TableCell>
      ))}
    </TableRow>
  )
}
